import http from './http';

// Backs the re-auth session-status poll and the updateReauthenticateSessionID entry thunk.
// The progress/device-info calls moved to features/reauthenticate/api.js (RTK Query).
export const reauthenticateStatusAPI = (sessionUUID) => {
    let config = {
        headers: {
            'X-Reauthenticate-Session': sessionUUID,
        },
    };
    return http.get('/reauthenticate/session/status', config);
};
